module.exports = __webpack_public_path__ + "static/SERVICEPAKETE-LARGE-b095ae17637100ceab07a4ddef4675f7.svg";